import Sidebar from '../Sidebar/'
import './index.scss'

import portfolioData from '../../utils/portfolioData'
import PortfolioCard from "../PortfolioCard"
import usePageMeta from '../../utils/usePageMeta'

const Portfolio = () => {
  usePageMeta({
    title: 'Portfolio – Greg Chui, Full-stack & AI Engineer',
    description:
      'Selected projects by Greg Chui: a Bitcoin OTC trading platform, a Miami real estate agency site, an accredited medical lab in Hong Kong, and more.',
    path: '/portfolio',
  })

  const portfolioArray = portfolioData.map(project => {
    return <PortfolioCard
      key={project.link}
      project={project}
    />
  })

  return (
    <>
      <div className="App">
        <Sidebar />
        <section className="page-contain">
          <h1 className="sr-only">Portfolio – selected projects by Greg Chui</h1>
          <div className="card-contain">
            {portfolioArray}
          </div>
        </section>
      </div>
    </>
  )
}

export default Portfolio